import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import couponModel from './couponModel'
import countryModel from '../common/models/countryModel'

const {
  fetchList,
  fetchAllChildren,
  fetchAll,
  fetchOne,
  create,
  update,
  deleteMany,
} = useModelStoreModule(couponModel)

const {
  fetchList: fetchCountries,
} = useModelStoreModule(countryModel)

const fetchCommissions = (ctx, id) => fetchAllChildren(ctx, id, 'commissions')

export default {
  model: couponModel,
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList,
    fetchAll,
    fetchOne,
    create,
    update,
    deleteMany,

    fetchCountries,
    fetchCommissions,
  },
}
